import './header-user.less'
import defaultImg from '@/assets/head-portrait.jpg'
import AppStore from './app-store'
import {toPersonalHub,toUpdatePwd} from '@/api/user'
export default {
  name:'header-user',
  data(){
    return {}
  },
  computed:{
    userInfo(){
      return this.$store.state.user.userInfo
    }
  },
  methods:{
    async logOut(){
      this.$store.dispatch('logout')
    },
    async toPersonalHub(){
      toPersonalHub()
    },
    async toUpdatePwd(){
      toUpdatePwd()
    }
  },
  render(){
    return (
      <div class="header-user">
        <AppStore />
        <ADropdown class="user-box">
          <div class="user-text">
            <div class="profile-photo">
              <img src={defaultImg} />
            </div>
            <div class="user-text-info">
              <span>{this.userInfo.name}</span>
              <span>{this.userInfo.dept}</span>
            </div>
            <aIcon type="down" />
          </div>
          <AMenu slot="overlay">
            <AMenuItem key="0" onClick={this.toPersonalHub}>
              <span>个人中心</span>
            </AMenuItem>
            <AMenuItem key="1" onClick={this.toUpdatePwd}>
              <span>修改密码</span>
            </AMenuItem>
            <AMenuItem key="2" onClick={this.logOut}>
              <span>退出系统</span>
            </AMenuItem>
          </AMenu>
        </ADropdown>
      </div>
    )
  }
}
